<template>
  <section id="popInvite" class="popup popInvite profile">
    <div class="popBody">
      <a class="close"
        ><font-awesome-icon icon="fas fa-times"></font-awesome-icon
      ></a>
      <section class="popHeader">
        <span class="fL primary">推薦賺雲林幣</span>
      </section>
      <section  class="popMain">
          嗨～我的好朋友，現在下載雲林幣扭一下2.0 App，賺雲林幣可到特店消費折抵！
          <br>記得註冊時輸入我的代碼: {{ user?.user?.myReferralCode }}
          <br />下載連結: https://yunlincoin.yunlin.gov.tw/DownloadNubi/Download <br />每成功推薦一位朋友，立即獲得 {{ point }} 枚雲林幣！
          <!-- <div class="flexV">
                          <span class="fM">成功邀請朋友</span>
                          <span class="fL third">10</span>
                      </div> -->
          <button
            class="button rounded border-0 text-white mt-4 fS"
            :class="{'bg-success': isCopied}"
            @click.prevent="copy">
            {{ isCopied ? '已複製' : '點我複製內文'}}
          </button>
      </section>
      <!-- <section class="popFooter">
        <a class="button rounded code white" @click.prevent="copy()">
          <div class="flexH">
            <div class="icon">
              <font-awesome-icon icon="fa-solid fa-check"></font-awesome-icon>
            </div>
            <span v-show="isCopied" class="fS gray">已複製</span>
          </div>
          <span class="fM">{{ displayReferralCode() }}</span>
          <input
            type="hidden"
            id="referral-code"
            :value="generateReferralCode()"
          />
        </a>
        <a class="button rounded line" :href="shareWithLINEUrl()">
          <div class="img">
            <img src="@/assets/icon/line.svg" />
          </div>
          <span class="fM">Line邀請好友</span>
        </a>
      </section> -->
    </div>
  </section>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    // 呼叫端把推薦活動帶進來,彈窗與複製出去的邀請文案才會顯示這個活動真正的獎勵。
    // 沒帶就退回原本的行為(見下方 point() 的 WARNING)。
    campaign: { type: Object, default: null },
  },
  data() {
    return {
      apiHost: process.env.VUE_APP_API_HOST,
      merchantId: process.env.VUE_APP_MERCHANT_ID,
      isCopied: false,
      // campaigns: [],
      referralCampaign: {}
    }
  },
  computed: {
    ...mapState(["user", "userInfo"]),
    //WARNING: 🔴 原本是 `this.referralCampaign?.reward_point || 50`,而
    //         referralCampaign 永遠是 `{}` —— created() 裡的 getCampaigns()
    //         2024-11-12 就被註解掉了(789897a「Remove getCampaigns in profile」),
    //         之後沒有任何地方填過它。所以 point 恆等於 50,而複製出去的邀請文案
    //         (下面 copyText 那段)就寫著「立即獲得 50 枚雲林幣」。
    //
    //         實際上一枚都不是 50:2026-09-24 查 dev tycard(E4 從 PROD 搬來的),
    //         四個推薦活動的獎勵是 10 / 10 / 3 / 10。
    //
    //         改成優先讀呼叫端帶進來的活動。用 ?? 不是 || —— 獎勵設 0 的活動
    //         不該被當成「沒帶」而跳回 50。
    //         (PR #64 review 指出。既有缺陷,不是這次搬遷造成的,但把 `referral`
    //          也納入判斷之後標品的推薦活動同樣會踩,所以一起修掉。)
    //
    //🟠 Profile.vue 那個入口沒有活動可帶(那頁是「我的」,不在任何活動底下),
    //   所以它仍然會顯示 50。要修得把 getCampaigns() 放回去,屬於另一件事。
    point() {
      return this.campaign?.reward_point
        ?? this.referralCampaign?.reward_point
        ?? 50;
    }
  },
  created() {
    // this.getCampaigns();
  },
  methods: {
    // getCampaigns() {
    //   this.getCampaignAPI()
    //     .then((res) => {
    //       this.campaigns = res.data.campaigns;
    //       this.campaigns.forEach((campaign) => {
    //         if (campaign.campaignPrototype === "referral-referrer") {
    //           this.referralCampaign = campaign;
    //         }
    //       });

    //     })
    //     .catch((err) => {
    //       console.log('getCampaigns', err);
    //     });
    // },
    // getCampaignAPI() {
    //   let config = {
    //     url: `${this.apiHost}/campaigns/v1/merchants/${this.merchantId}/participations/uuid/${this.user.userId}/member_id/${this.userInfo.memberId}?includeNonJoined=true&includeInactive=true&publisherType=municipal`,
    //     methods: "GET"
    //   };
    //   return this.$http(config);
    // },
    openPop() {
      var popInvite = document.getElementById("popInvite");
      var close = popInvite.getElementsByClassName("close")[0];
      close.onclick = function () {
        popClose();
      };
      window.onclick = function (event) {
        if (event.target == popInvite) {
          popClose();
        }
      };
      function popClose() {
        popInvite.style.display = "none";
        document.body.style.overflow = "scroll";
      }
      popInvite.style.display = "flex";
      document.body.style.overflow = "hidden";
    },
    async copy() {
      const text = `嗨～我的好朋友，現在下載雲林幣扭一下2.0 App，賺雲林幣可到特店消費折抵
記得註冊時輸入我的代碼: ${this.user?.user?.myReferralCode}
下載連結: https://yunlincoin.yunlin.gov.tw/DownloadNubi/Download
每成功推薦一位朋友，立即獲得 ${this.point} 枚雲林幣！`;

      try {
        await navigator.clipboard.writeText(text);
        this.isCopied = true;
        setTimeout(() => {
          this.isCopied = false;
        }, 1000);
      } catch (err) {
        console.error('複製失敗:', err);
      }
    },
  }
}
</script>
